import { render, staticRenderFns } from "./roiFunnel.vue?vue&type=template&id=668efa96"
import script from "./roiFunnel.vue?vue&type=script&lang=js"
export * from "./roiFunnel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports